// extracted by mini-css-extract-plugin
module.exports = {"notificationsContainer":"Notifications_notificationsContainer__5x2-m"};